export const getSalonAccess = (access, salonId) =>
  (access?.salons || []).find((salon) => Number(salon.salon_id) === Number(salonId));

export const SUBSCRIPTION_FEATURE_BY_PERMISSION = {
  'client_messages.access': 'chat_directe',
  'salon.manage_theme': 'theme_modifiable',
};

const subscriptionAllowsPermission = (salon, code) => {
  const feature = SUBSCRIPTION_FEATURE_BY_PERMISSION[code];
  return !feature || salon?.subscription_features?.[feature] === true;
};

const salonAllowsPermission = (salon, code) => Boolean(
  salon
  && subscriptionAllowsPermission(salon, code)
  && (salon.is_owner || salon.permission_codes?.includes(code)),
);

export const hasSalonPermission = (access, salonId, code) => {
  const salon = getSalonAccess(access, salonId);
  return salonAllowsPermission(salon, code);
};

export const canSeeDomain = (access, code) =>
  (access?.salons || []).some((salon) => salonAllowsPermission(salon, code));
